document.addEventListener('click', (event) => {
  const summary = event.target.closest('.facets__summary');
  if (!summary) return;

  const current = summary.closest('details');
  if (!current) return;

  document.querySelectorAll('.facets__disclosure[open]').forEach((item) => {
    if (item !== current) {
      item.removeAttribute('open');
    }
  });
});